import React from 'react';
import CustomTabHeader from './CustomTabHeader';

type Props = {
  selectedTabIndex: number;
  onChange: (e: React.SyntheticEvent, newValue: number) => void;
  tabs: ICustomTab[];
  fitContent?: boolean;
};

const CustomTabs = ({
  selectedTabIndex,
  onChange,
  tabs,
  fitContent = false
}: Props) => {
  const hasMultipleTabs = tabs.filter((tab) => !tab.isHidden).length > 1;

  return (
    <div
      className={` 
        ${fitContent ? '' : 'full-width'}
        custom-tabs-header 
        ${hasMultipleTabs ? 'with-tabs' : 'no-tabs'}
      `}
    >
      {hasMultipleTabs &&
        tabs.map(
          (tab, index) =>
            !tab.isHidden && (
              <CustomTabHeader
                key={index}
                index={index}
                label={tab.label}
                onClick={onChange}
                isSelected={selectedTabIndex === index}
                isDisabled={tab.isDisabled}
              />
            )
        )}
    </div>
  );
};

export default CustomTabs;

export interface ICustomTab {
  key: string | number;
  label: string;
  isDisabled?: boolean;
  isHidden?: boolean;
}
